import React from 'react'

import ContactSection from '../components/Sections/ContactSection'
import AboutSection from '../components/Sections/AboutSection'
import DownloadSection from '../components/Sections/DownloadSection'
import FeaturesSection from '../components/Sections/FeaturesSection'
import HeaderSection from '../components/Sections/HeaderSection'
import PricesContactSection from '../components/Sections/PricesContactSection'
import ScreenshotsSection from '../components/Sections/ScreenshotsSection'
import SubscribeSection from '../components/Sections/SubscribeSection'
import screenshot1 from '../resources/screenshot1-min.png'
import screenshot2 from '../resources/screenshot2-min.png'
import screenshot3 from '../resources/screenshot3-min.png'
import screenshot4 from '../resources/screenshot4-min.png'
import screenshot5 from '../resources/screenshot5-min.png'
import screenshot6 from '../resources/screenshot6-min.png'
import screenshot7 from '../resources/screenshot7-min.png'
import logo from '../resources/logo.png'
import demoQrCode from '../resources/qr-code-demo.jpg'

const scProgram = { src: screenshot1, alt: 'Program' }
const scMenu = { src: screenshot2, alt: 'Menu' }
const scDetail = { src: screenshot3, alt: 'Detail' }
const scNotes = { src: screenshot4, alt: 'Notes' }
const scChat = { src: screenshot5, alt: 'Chat' }
const scFeedback = { src: screenshot6, alt: 'Feedback' }
const scReport = { src: screenshot7, alt: 'Report problem' }

const IndexPage = () => (
  <div>
    <HeaderSection
      bigLogo={logo}
      description="Your number One application for conferences"
      findMoreLabel="Find more about Conf One"
      images={[scProgram, scMenu, scDetail]}
    />
    <AboutSection
      title="About Conf One"
      description="Conf One application allows attendees to view all important information about your conference in the browser as well as an mobile application. Many interactive features will boost their overall positive impression."
      features={[
        {
          title: 'Super Fast',
          description:
            'Using latest technologies is the application blazing fast and works even offline without internet connection.',
          faIcon: 'rocket',
        },
        {
          title: 'Feedback',
          description:
            'Get instant feedback like rating of the presentations or issues in the venue to better organize your event. ',
          faIcon: 'comments-o',
        },
        {
          title: 'Feature Rich',
          description:
            'Let your attendees take notes, interact in thematic group chats or navigate through the programme with ease.',
          faIcon: 'lightbulb-o',
        },
      ]}
    />
    <FeaturesSection
      title="Features"
      features={[
        {
          title: 'Super Fast',
          description:
            'Access all the content without waiting for page to load.',
          faIcon: 'rocket',
          image: scProgram,
        },
        {
          title: 'Offline',
          description:
            'All supported browsers allows you to use application without requiring the internet connectivity.',
          faIcon: 'ban',
          image: scNotes,
        },
        {
          title: 'Interactive',
          description:
            'Users can see interactive schedule, write their own notes or chat with others',
          faIcon: 'lightbulb-o',
          image: scChat,
        },
        {
          title: 'Customizable',
          description:
            'Theme the application to match your brand. Select only the features you want.',
          faIcon: 'wrench',
          image: scMenu,
        },
        {
          title: 'Feedback',
          description:
            'Ask your attendees anything, collect feedback or respond to problems immediately when they happen.',
          faIcon: 'comments-o',
          image: scFeedback,
        },
        {
          title: 'User Friendly',
          description:
            'Modern responsive design that works on all devices. Seamless installation without requiring heavy app store.',
          faIcon: 'heartbeat',
          image: scReport,
        },
      ]}
    />
    <SubscribeSection />
    <ScreenshotsSection
      title="Screenshots"
      description="Get impression about the application look. Of course you can customize it with own content, colors, images and logo."
      screenshots={[
        scProgram,
        scMenu,
        scDetail,
        scNotes,
        scChat,
        scFeedback,
        scReport,
      ]}
    />
    <DownloadSection
      title="Try it now"
      description="Try out our demo application for the conference 'Výchova k životu 2018.'"
      demoLink="https://demo.conf.one/"
      demoImage={screenshot1}
      demoQrCode={demoQrCode}
    />
    <PricesContactSection
      title="Prices"
      description="Please, contact us for getting the price list."
      formProps={{
        name: 'contact-form',
        id: 'contact-form',
        location: 'Bratislava, Slovakia',
        email: 'info@conf-one.com',
      }}
    />
    <ContactSection
      title="Contact us"
      description=""
      email="info@conf-one.com"
      facebookLink="https://www.facebook.com/Instea-2058192477758523/?ref=br_rs"
    />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js